module.exports = __webpack_public_path__ + "static/img/yakshof.4d5cfd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yakshof.png
// module id = pQBu
// module chunks = 1